// index.js or main file
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./utils/swalTheme.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Login from "./pages/login/login";
import AdminRedirect from "./adminRedirect/admin";
import Admin from "./admin/admin";
import Home from "./admin/pages/home/home";
import Rules from "./admin/pages/rules/rules";
import { Provider } from "react-redux";
import { store } from "./admin/store";
import LoginPage from "./admin/pages/login/login";
import TalentPoses from "./pages/talentPoses/TalentPoses";
import TalentUpload from "./pages/talentUpload/TalentUpload";
import TalentUploadGallery from "./pages/talentUploadGallery/TalentUploadGallery";
import GamePage from "./pages/game/GamePage";
import HowToPlay from "./pages/howToPlay/HowToPlay";
import TalentGallery from "./pages/gallery/TalentGallery";
import LeaderboardLayout from "./pages/leaderboard/LeaderboardLayout";
import JuryLogin from "./pages/jury/JuryLogin";
import JuryVote from "./pages/jury/JuryVote";
import JuryMembers from "./admin/pages/jury/JuryMembers";
import USER from "./pages/dddUI/user";
import CustomizeSpotTheme from "./admin/pages/customize-spot-theme/CustomizeSpotTheme";
import TalentUploads from "./admin/pages/talent-uploads/TalentUploads";
import MosaicSettings from "./admin/pages/mosaic/MosaicSettings";
import MosaicWall from "./pages/mosaic/MosaicWall";
import { clearThemeBodyBackground } from "./utils/themeBodyBackground";

function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    body.classList.remove("common-bg");
    if (location.pathname.startsWith("/admin")) {
      clearThemeBodyBackground();
    }
  }, [location]);
}

function App() {
  usePageBackground();

  return (
    <Provider store={store}>
      <Routes>
        <Route path="/admin">
          <Route index element={<Admin><Home /></Admin>} />
          <Route path="rules" element={<Admin><Rules /></Admin>} />
          <Route path="customize-spot" element={<Admin><CustomizeSpotTheme /></Admin>} />
          <Route path="uploads" element={<Admin><TalentUploads /></Admin>} />
          <Route path="jury" element={<Admin><JuryMembers /></Admin>} />
          <Route path="mosaic" element={<Admin><MosaicSettings /></Admin>} />
          <Route path="superadmin" element={<LoginPage />} />
        </Route>

        <Route
          path="*"
          element={
            <USER>
              <Routes>
                <Route index element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/how-to-play" element={<HowToPlay />} />
                <Route path="/game" element={<GamePage />} />
                <Route path="/gallery" element={<TalentGallery />} />
                <Route path="/mosaic" element={<MosaicWall />} />
                <Route path="/leaderboard" element={<LeaderboardLayout />} />
                <Route path="/jury/login" element={<JuryLogin />} />
                <Route path="/jury/vote" element={<JuryVote />} />
                <Route path="/yoga-poses" element={<TalentPoses />} />
                <Route path="/yoga-upload" element={<TalentUpload />} />
                <Route path="/yoga-gallery" element={<TalentUploadGallery />} />
                <Route path="/AdminRedirect" element={<AdminRedirect />} />
              </Routes>
            </USER>
          }
        />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
